var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-card",
        { staticClass: "rounded-lg fill-height" },
        [
          _c("v-divider"),
          _c(
            "v-card-title",
            [
              _vm._v("HighLevel and Agent CRM Integrations "),
              _c(
                "v-btn",
                {
                  attrs: {
                    text: "",
                    href: _vm.highlevelRegistrationUrl,
                    target: "_blank",
                    icon: "",
                  },
                },
                [_c("v-icon", [_vm._v("mdi-open-in-new")])],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-text",
            [
              _c("p", [
                _vm._v(" If you have a HighLevel or Agent CRM "),
                _c(
                  "a",
                  {
                    attrs: {
                      href: _vm.highlevelRegistrationUrl,
                      target: "_blank",
                    },
                  },
                  [_vm._v("account")]
                ),
                _vm._v(
                  ", you can connect it here in order to handle processing of meeting recordings. Look for Video Conference custom fields to use in building your workflows. "
                ),
              ]),
              _vm.loading
                ? _c("v-progress-linear", { attrs: { indeterminate: "" } })
                : _vm._e(),
              _c(
                "v-row",
                _vm._l(_vm.integrations, function (item) {
                  return _c(
                    "v-col",
                    {
                      key: item.locationId,
                      staticClass: "d-flex flex-column",
                      attrs: { cols: "12", sm: "6", lg: "3", xl: "2" },
                    },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass:
                            "elevation-5 flex d-flex flex-column rounded-lg",
                        },
                        [
                          _c(
                            "v-card-title",
                            {
                              staticClass: "pa-4",
                              staticStyle: {
                                "background-color": "#fff",
                                "min-height": "120px",
                              },
                              attrs: { "min-height": "120" },
                            },
                            [
                              item.location && item.location.logoUrl
                                ? _c("v-img", {
                                    attrs: {
                                      src: item.location.logoUrl,
                                      contain: "",
                                      "max-height": "75",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _c(
                            "v-card-title",
                            { staticClass: "font-weight-bold" },
                            [
                              item.location
                                ? _c("span", { staticClass: "pr-2" }, [
                                    _vm._v(
                                      _vm._s(
                                        item.location
                                          ? item.location.name
                                          : "Location"
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                          _c(
                            "v-card-subtitle",
                            [
                              item.room_name
                                ? [
                                    _vm._v(" " + _vm._s(item.room_name) + " "),
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: { icon: "", "x-small": "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.showConnectRoomDialog(
                                              item
                                            )
                                          },
                                        },
                                      },
                                      [_c("v-icon", [_vm._v("mdi-pencil")])],
                                      1
                                    ),
                                  ]
                                : _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        "x-small": "",
                                        color: "primary",
                                        text: "",
                                        outlined: "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.showConnectRoomDialog(item)
                                        },
                                      },
                                    },
                                    [_vm._v("Connect Room")]
                                  ),
                            ],
                            2
                          ),
                          _c(
                            "v-card-actions",
                            [
                              _c("v-spacer"),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    "x-small": "",
                                    color: "red",
                                    icon: "",
                                    title: "Delete",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.confirmDeleteIntegration(item)
                                    },
                                  },
                                },
                                [
                                  _c("v-icon", [
                                    _vm._v("mdi-trash-can-outline"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "pb-4" },
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  staticClass: "mt-8",
                  attrs: { href: _vm.highLevelOauthUrl, color: "primary" },
                },
                [_vm._v("Add Integration")]
              ),
              _c("v-spacer"),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { width: "60%", "max-width": "500" },
          model: {
            value: _vm.show_confirm_delete_dialog,
            callback: function ($$v) {
              _vm.show_confirm_delete_dialog = $$v
            },
            expression: "show_confirm_delete_dialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "text-h5" }, [
                _vm._v(" Delete Integration? "),
              ]),
              _c("v-card-text", [
                _vm._v(" Are you sure you want to delete "),
                _c("strong", [
                  _vm._v(
                    _vm._s(
                      _vm.delete_integration.location
                        ? _vm.delete_integration.location.name
                        : "this connection"
                    )
                  ),
                ]),
                _vm._v("? "),
              ]),
              _c("v-divider"),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", text: "" },
                      on: {
                        click: function ($event) {
                          _vm.show_confirm_delete_dialog = false
                        },
                      },
                    },
                    [_vm._v(" Cancel ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "red",
                        loading: _vm.loading,
                        disabled: _vm.loading,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.deleteIntegration()
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("mdi-delete")]), _vm._v(" Delete ")],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { width: "60%", "max-width": "500" },
          model: {
            value: _vm.show_connect_room_dialog,
            callback: function ($$v) {
              _vm.show_connect_room_dialog = $$v
            },
            expression: "show_connect_room_dialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "text-h5" }, [
                _vm._v(" Connect Room "),
              ]),
              _c(
                "v-card-text",
                [
                  _vm._v(
                    " To fully integrate, select the room you want to use for this integration. This will be the room used in the links that are auto-created for your meetings. "
                  ),
                  _c("v-select", {
                    staticClass: "mt-2",
                    attrs: {
                      items: _vm.rooms.rooms,
                      "item-text": "post_title",
                      "item-value": "ID",
                      outlined: "",
                      dense: "",
                    },
                    model: {
                      value: _vm.selected_room,
                      callback: function ($$v) {
                        _vm.selected_room = $$v
                      },
                      expression: "selected_room",
                    },
                  }),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "primary", text: "" },
                      on: {
                        click: function ($event) {
                          _vm.show_connect_room_dialog = false
                        },
                      },
                    },
                    [_vm._v(" Cancel ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "success",
                        loading: _vm.connecting_room,
                        disabled: _vm.connecting_room,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.connectRoom()
                        },
                      },
                    },
                    [_vm._v(" Connect ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }